define((require) => {
    "use strict";

    var Action = require("editor/util/Action");

    return Action.extend({

        _group: null,

        _experience: null,

        _project: null,

        /**
         * Constructor.
         *
         * @param  {GroupModel} group           The <tt>GroupModel</tt>, if any.
         * @param  {ExperienceModel} experience The current <tt>ExperienceModel</tt>.
         * @param  {ProjectModel} project       The <tt>ProjectModel</tt> if in a project context.
         * Below parameter are used for Editor 2.0
         * @param experienceCollection,         Details of Experience Collections.
         */
        constructor: function(group, experience, project, experienceCollection) {
            this.__super();

            this._group = group;
            this._experience = experience;
            this._project = project;
            this._collections = experienceCollection;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/AddVariantAction.js